<template>
  <section class="fl-section fl-section--cream" style="min-height: 90vh">
    <div class="fl-wrap">
      <div style="max-width: 720px; margin-bottom: 44px">
        <span class="fl-eyebrow" data-reveal="0">Blog</span>
        <h1 class="fl-h2" data-reveal="60" style="margin-top: 18px">
          İçerik üreticisi rehberleri
        </h1>
        <p class="fl-lead" data-reveal="120" style="margin-top: 18px">
          Affiliate’in nasıl işlediğinden vergi mevzuatına, fiyat
          belirlemeden etkileşim artırmaya kadar; işini büyütürken ihtiyaç
          duyacağın pratik bilgiler.
        </p>
      </div>

      <div class="fl-chips" data-reveal="0">
        <button
          v-for="cat in categories"
          :key="cat"
          type="button"
          class="fl-chip"
          :class="{ 'is-active': activeCategory === cat }"
          @click="activeCategory = cat"
        >
          {{ cat }}
        </button>
      </div>

      <div class="fl-posts">
        <router-link
          v-for="post in filteredPosts"
          :key="post.slug"
          :to="'/blog/' + post.slug"
          class="fl-post"
        >
          <div class="fl-post__cover" :style="{ background: post.cover }">
            <i class="mdi" :class="post.icon"></i>
          </div>
          <div class="fl-post__body">
            <div class="fl-post__meta">
              <span>{{ post.category }}</span>
              <span>·</span>
              <span>{{ formatDate(post.date) }} · {{ post.readMinutes }} dk</span>
            </div>
            <h3>{{ post.title }}</h3>
            <p>{{ post.excerpt }}</p>
            <span class="fl-post__more">
              Yazıyı oku <i class="mdi mdi-arrow-right"></i>
            </span>
          </div>
        </router-link>
      </div>

      <div class="fl-endcta" style="margin-top: 56px">
        <div>
          <h3>Okumakla kalma, uygula.</h3>
          <p>
            Ücretsiz hesabını aç, ilk affiliate linkini oluştur ve açık
            kampanyalara başvur.
          </p>
        </div>
        <a class="fl-btn fl-btn--primary" href="/account/register">
          Ücretsiz Başla
          <i class="mdi mdi-arrow-right"></i>
        </a>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { Vue, Component } from "vue-property-decorator";
import { blogPosts, blogCategories } from "../blog-posts";
import { initReveal } from "../reveal";

@Component
export default class BlogList extends Vue {
  public categories = blogCategories;
  public activeCategory = "Tümü";
  private teardown: (() => void) | null = null;

  get filteredPosts() {
    const sorted = blogPosts
      .slice()
      .sort((a, b) => (a.date < b.date ? 1 : -1));
    if (this.activeCategory === "Tümü") return sorted;
    return sorted.filter((p) => p.category === this.activeCategory);
  }

  public formatDate(iso: string): string {
    const months = [
      "Ocak",
      "Şubat",
      "Mart",
      "Nisan",
      "Mayıs",
      "Haziran",
      "Temmuz",
      "Ağustos",
      "Eylül",
      "Ekim",
      "Kasım",
      "Aralık",
    ];
    const d = new Date(iso);
    return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
  }

  public mounted() {
    window.scrollTo(0, 0);
    this.teardown = initReveal(this.$el);
  }

  public beforeDestroy() {
    if (this.teardown) this.teardown();
  }
}
</script>
